
import { computed, defineComponent, PropType } from "vue";
import { TicketTypeEnum } from "@/models/enums";
import { DepartureTicketType } from "@/models/www/DeparturePrice";

export default defineComponent({
	props: {
		id: String,
		name: String,
		disabled: {
			type: Boolean,
			required: false,
		},
		value: String,
		modelValue: String,
		ticket: {
			type: Object as PropType<DepartureTicketType>,
			required: true,
		},
	},
	setup(props, { emit }) {
		const inputValue = computed({
			get(): any {
				return props.modelValue;
			},
			set(value: any) {
				emit("update:modelValue", value);
			},
		});

		return { inputValue, TicketTypeEnum };
	},
});
